import chroma from 'chroma-js';

// Color helpers
// ---------------------------------------------------------

const LIGHT = chroma('#ffffff');
const DARK = chroma('#000000').set('hsl.l', 0.1);
const DARK_BLUE = chroma('#13182C');

export const theme = {
  name: 'HoxTheme',
  rem: 16,
  palette: {
    foreground: {
      primary: LIGHT.css(),
      inverse: DARK.css(),
      inputPlaceholder: LIGHT.alpha(0.3).css(),
      cta: '#264cb2',
      listBlue: 'rgb(18, 113, 173)',
      severity: {
        MALICIOUS: '#F53B57',
        NOT_MALICIOUS: '#1DD1A1',
        NOT_RATED: 'rgba(255, 255, 255, 0.4)',
        INCONCLUSIVE: 'rgba(255, 255, 255, 0.4)',
      },
      divider: 'rgba(151, 151, 151, 0.2)',
      enabled: '#00A8FF',
      disabled: 'rgba(204,231,255,0.3)',
    },
    severity: {
      MALICIOUS: '#F53B57',
      NOT_MALICIOUS: '#1DD1A1',
      NOT_RATED: 'rgba(255, 255, 255, 0.4)',
      INCONCLUSIVE: 'rgba(255, 255, 255, 0.4)',
    },
    divider: 'rgba(151, 151, 151, 0.2)',
    background: {
      primary: DARK_BLUE.css(),
      buttonRound: '#2a2f41',
      card: '#171e3a',
      incidentCheckbox: '#00A8FF',
      cardLevel1: '#192343',
      cardUserDropdownDark: '#2E334E',
      cardUserDropdownLight: '#575C72',
      breadcrumbs: '#222f5c',
      inverse: LIGHT.css(),
      input: LIGHT.alpha(0.1).css(),
      inputOpaque: chroma
        .blend(DARK_BLUE, LIGHT.set('hsl.l', 0.1), 'screen')
        .css(),
      inputActive: LIGHT.alpha(0.2).css(),
      inputActiveOpaque: chroma
        .blend(DARK_BLUE, LIGHT.set('hsl.l', 0.2), 'screen')
        .css(),
      progressBarFill: '#00a8ff',
      dropdown: '#4f5267',
      tooltipBackground: '#0A0F21',
      currentRank: '#0B173E',
      dropdownBackground: '#2E344E',
    },
    indicator: {
      positive: '#264cb2',
      negative: '#ee295c',
      golden: '#ffc73c',
      teal: '#3CCBE7',
      blue: '#0575B7',
      lightBlue: '#0A72B1',
    },
    feedStatus: {
      reported: '#06D6A0',
      missed: '#FFFFFF',
      clicked: '#F53B57',
    },
    chart: {
      primary: '#23CCF7',
      secondary: '#1C4569',
    },
  },
  typography: {
    heading: {
      fontFamily: '"Montserrat", sans-serif',
    },
    body: {
      fontFamily: '"Nunito Sans", sans-serif',
    },
  },
};

// Enable fonts
const fontLinkElement = document.createElement('link');
fontLinkElement.href =
  'https://fonts.googleapis.com/css?family=Montserrat:400,600,700|Nunito+Sans:400,600,700&display=swap';
fontLinkElement.rel = 'stylesheet';
document.head.appendChild(fontLinkElement);

export type WithTheme<TProps extends object = {}> = TProps & {
  theme: typeof theme;
};
